import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../customComponent/BreadCrumbs";
import { breadcrumbNameMap } from "../../utils/helperData";
import { Box, Modal, TextField } from "@mui/material";
import { IoIosSearch } from "react-icons/io";
import { RxCrossCircled } from "react-icons/rx";
import { MdEmail } from "react-icons/md";
import { PiPhoneOutgoingFill } from "react-icons/pi";
import { IoMdPerson } from "react-icons/io";
import SuccessBackground from "../../../asesst/SuccessBackground.svg";
import Tick from "../../../asesst/tick.svg";
import { HiDotsVertical } from "react-icons/hi";
import { HiPlusSmall } from "react-icons/hi2";
import { addProject } from "../../../redux/action/ProjectManagement/ProjectManagentAction";
import { useDispatch, useSelector } from "react-redux";
import { fetchInspectors, uploadFiles } from "../../../redux/action/InspectorManagement/AddInspectorAction";
import { useNavigate } from "react-router";
import { MANAGE_PROJECT } from "../../utils/RouteConstant";

const AddProject = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [formData, setFormData] = useState({
    client_name: "",
    client_id: "",
    project_id:"",
    name: "",
    description: "",
    inspector_id: [],
  });
  const [errors, setErrors] = useState({});
  const [errormessage, setErrorMessage] = useState()
    const [pendingInspectors, setPendingInspectors] = useState([]);
    const [assignedInspectors, setAssignedInspectors] = useState([]);
  const [openAddInspectorModal, setOpenAddInspectorModal] = useState(false);
  const [openSaveModal, setOpenSaveModal] = useState(false);
  const [removeModalOpen, setRemoveModalOpen] = useState(false);
  const [inspectorToRemove, setInspectorToRemove] = useState(null);

  const handleOpenSaveModal = () => setOpenSaveModal(true);
  const handleOpenAddInspectorModal = () => setOpenAddInspectorModal(true);
  const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const { inspectorData, isLoading, error, totalCount } = useSelector(
    (state) => state.inspector
  );

  useEffect(() => {
    dispatch(fetchInspectors(currentPage, searchTerm, itemsPerPage));
  }, [dispatch, currentPage, searchTerm]);

  const handleCloseAddInspectporModal = () => {
    setOpenAddInspectorModal(false);
     setPendingInspectors([]);
    setSearchTerm("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

    // const toggleInspectorSelection = (id) => {
    //   setPendingInspectors((prevSelected) => {
    //     if (prevSelected.includes(id)) {
    //       return prevSelected.filter((inspectorId) => inspectorId !== id);
    //     } else {
    //       return [...prevSelected, id];
    //     }
    //   });
    // };

  const toggleInspectorSelection = (id) => {
    setPendingInspectors((prevSelected) => {
      const isAssigned = assignedInspectors.includes(id);

      if (prevSelected.includes(id)) {
        return prevSelected.filter((inspectorId) => inspectorId !== id);
      } else if (isAssigned) {
        setAssignedInspectors((prev) =>
          prev.filter((inspectorId) => inspectorId !== id)
        );
        return prevSelected;
      } else {
        return [...prevSelected, id];
      }
    });
  };
   const isInspectorSelected = (inspectorId) => {
     return (
       pendingInspectors.includes(inspectorId) ||
       assignedInspectors.includes(inspectorId)
     );
   };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.client_name)
      newErrors.client_name = "Client Name is required";
    if (!formData.client_id) newErrors.client_id = "Client ID is required";
    if (!formData.project_id) newErrors.project_id = "Project ID is required";
    if (!formData.name) newErrors.name = "Project Name is required";
    if (!formData.description)
      newErrors.description = "Project Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Remove inspector modal handlers

 const handleOpenRemoveModal = (e, inspectorId) => {
   e.preventDefault(); 
   e.stopPropagation();
   setInspectorToRemove(inspectorId);
   setRemoveModalOpen(true);
 };
  const handleCloseRemoveModal = () => {
    setRemoveModalOpen(false);
    setInspectorToRemove(null);
  };

  const handleRemoveInspector = () => {
    if (inspectorToRemove) {
      setAssignedInspectors((prev) =>
        prev.filter((id) => id !== inspectorToRemove)
      );
    }
    handleCloseRemoveModal();
  };


  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      let imagePath = ""; 
       if (file) {
         const uploadResponse = await dispatch(uploadFiles([file]));
        if (uploadResponse.success) {
           imagePath = uploadResponse?.data?.data[0]?.fileName;
        } else {
          console.error("File upload failed:", uploadResponse.error);
          return;
        }
       }
      const projectData = {
        ...formData,
        inspector_id: assignedInspectors,
        document: imagePath,
      };
       const addProjectResponse = await dispatch(addProject(projectData));
        if (addProjectResponse.success) {
          handleOpenSaveModal();
        } else {
          console.error("Failed to add project:", addProjectResponse.error);
        }
    } catch (error) {
     setErrorMessage(error?.response?.data?.message);
    }
  };

  const truncateString = (str) => {
    if (str?.length > 12) {
      return str.slice(0, 10) + "...";
    }
    return str;
  };

  const selectedInspectorData = inspectorData?.data?.filter((inspector) =>
    assignedInspectors.includes(inspector?._id)
  );

  const handleAssignInspector = () => {
    setAssignedInspectors((prev) => [...prev, ...pendingInspectors]);
    handleCloseAddInspectporModal();
  };

  const handleAddCancelButton = () => {
    navigate(MANAGE_PROJECT);
  };


// ........................ File Upload .const...............................

    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState("");
    const [fileName, setFileName] = useState("");

    // Handle file input change
    const handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        showPreview(file);
        setFileName(file.name);
      }
    };

    // Handle drag and drop
    const handleDragOver = (event) => {
      event.preventDefault();
      event.currentTarget.classList.add("active");
    };

    const handleDragLeave = (event) => {
      event.currentTarget.classList.remove("active");
    };

    const handleDrop = (event) => {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      if (file) {
        showPreview(file);
        setFileName(file.name);
      }
      event.currentTarget.classList.remove("active");
    };

    // Show preview of the uploaded file
    const showPreview = (file) => {
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = () => {
          setPreview(reader.result);
          setFile(file);
        };
        reader.readAsDataURL(file);
      }
    };

    // Handle file deletion
    const handleDelete = () => {
      setFile(null);
      setPreview("");
      setFileName("");
    };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-3xl font-bold mb-6">Project Management</h2>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </div>
      <div className="mx-auto bg-white shadow-lg rounded-lg p-8">
        <div>
          <h2 className="text-2xl font-base font-poppins mb-8 text-[#202224]">
            Add New Project
          </h2>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSave();
          }}
        >
          <div>
            <h3 className="text-base font-base text-[#1C3664] mb-2">
              Project Details
            </h3>
            <div
              style={{ borderBottom: "3px solid #1C3664", width: "5%" }}
            ></div>
            <div className="space-y-4 md:space-y-6 pt-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                <TextField
                  label="Client Name *"
                  name="client_name"
                  value={formData.client_name}
                  onChange={handleInputChange}
                  error={!!errors.client_name}
                  helperText={errors.client_name}
                />

                <TextField
                  label="Client ID *"
                  name="client_id"
                  value={formData.client_id}
                  onChange={handleInputChange}
                  error={!!errors.client_id}
                  helperText={errors.client_id}
                />

                <TextField
                  label="Project Name *"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  error={!!errors.name}
                  helperText={errors.name}
                />

                <TextField
                  label="Project ID *"
                  name="project_id"
                  value={formData.project_id}
                  onChange={handleInputChange}
                  error={!!errors.project_id}
                  helperText={errors.project_id}
                />
                <div className="upload-container relative flex flex-col items-center justify-between w-full">
                  {/* <div className="text-base font-semibold">Upload Image</div> */}
                  <div
                    className="drop-area w-full rounded-md border border-solid border-slate-300 transition-all hover:border-black text-center"
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  >
                    <label
                      htmlFor="file-input"
                      className="block w-full h-full text-gray-500 p-4 text-base cursor-pointer"
                    >
                      {!preview ? (
                        "Upload image or click to browse"
                      ) : (
                        <div className="preview-container flex justify-between items-center gap-4 p-4">
                          <div
                            className="preview-image w-40 h-24 bg-cover bg-center rounded-md"
                            style={{ backgroundImage: `url(${preview})` }}
                          ></div>
                          {/* <span className="file-name text-sm font-medium">
                          {fileName}
                        </span> */}
                          <RxCrossCircled
                            onClick={handleDelete}
                            className="h-8 w-8 cursor-pointer"
                          />
                        </div>
                      )}
                    </label>
                    <input
                      name="file"
                      type="file"
                      id="file-input"
                      accept="image/*"
                      className="hidden"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            <TextField
              label="Project Description *"
              name="description"
              multiline
              minRows={6}
              maxRows={6}
              sx={{ resize: "none", marginTop: "40px", width: "100%" }}
              variant="outlined"
              value={formData.description}
              onChange={handleInputChange}
              error={!!errors.description}
              helperText={errors.description}
            />
          </div>

          {assignedInspectors.length === 0 ? (
            <div>
              <h3 className="text-base font-base text-[#1C3664] mt-6 mb-2">
                Inspector Details
              </h3>
              <div
                style={{ borderBottom: "3px solid #1C3664", width: "5%" }}
              ></div>

              <div
                onClick={handleOpenAddInspectorModal}
                className="relative w-full sm:w-64 mt-8 flex-grow sm:flex-grow-0"
              >
                <input
                  type="text"
                  placeholder="Search inspector by name and email"
                  className="w-full lg:w-[400px] pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              </div>
            </div>
          ) : (
            <div className="mt-6">
              <div className="flex flex-col sm:flex-row justify-between items-center mb-6 space-y-4 sm:space-y-0 sm:space-x-4">
                <div className="  ">
                  <h3 className="text-base font-base text-[#1C3664] mt-6 mb-2">
                    Inspector Details
                  </h3>
                  <div
                    style={{ borderBottom: "3px solid #1C3664", width: "50%" }}
                  ></div>
                </div>
                <div
                  style={{ border: "1px solid #1C3664", borderRadius: "8px" }}
                >
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleOpenAddInspectorModal();
                    }}
                    className="w-full sm:w-auto text-[#1C3664] px-4 py-2 rounded-lg flex items-center justify-center"
                  >
                    <HiPlusSmall className="mr-2 text-lg" />
                    Add New
                  </button>
                </div>
              </div>
              <div className="overflow-x-auto mt-8">
                <table className="min-w-full bg-white border border-gray-200">
                  <thead>
                    <tr className="bg-gray-100 text-left">
                      <th className="py-3 px-6 font-medium text-gray-600">
                        S No.
                      </th>
                      <th className="py-3 px-6 font-medium text-gray-600">
                        Inspector Name
                      </th>
                      <th className="py-3 px-6 font-medium text-gray-600">
                        Inspector ID
                      </th>
                      <th className="py-3 px-6 font-medium text-gray-600">
                        Email Address
                      </th>
                      <th className="py-3 px-6 font-medium text-gray-600">
                        Mobile Number
                      </th>
                      <th className="py-3 px-6 font-medium text-gray-600"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedInspectorData?.map((project, index) => (
                      <tr key={index} className="border-t">
                        <td className="py-3 px-6 text-gray-500">{index + 1}</td>
                        <td className="py-3 px-6 text-gray-500">
                          {project?.inspector_name}
                        </td>
                        <td className="py-3 px-6 text-gray-500">
                          {project?.id}
                        </td>
                        <td className="py-3 px-6 text-gray-500">
                          {project?.email}
                        </td>
                        <td className="py-3 px-6 text-gray-500">
                          {project?.mobile_number}
                        </td>
                        <td className="py-3 px-6 text-gray-500">
                          <button
                            onClick={(e) =>
                              handleOpenRemoveModal(e, project?._id)
                            }
                            className="text-gray-400 hover:text-gray-500"
                          >
                            <HiDotsVertical />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {errormessage && (
            <div className="text-red-500 text-sm mt-2">{errormessage}</div>
          )}

          <div className="flex justify-end space-x-4 mt-4">
            <button
              onClick={handleAddCancelButton}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-[#1C3664] text-white rounded-md"
            >
              Save Details
            </button>
          </div>
        </form>
        <br />
      </div>

{/* .................. Remove Confirmation Modal ........................... */}

      <Modal
        open={removeModalOpen}
        onClose={handleCloseRemoveModal}
        className="justify-center items-center flex"
      >
        <Box className="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto my-20">
          <div className="text-center">
            <h2 className="text-xl font-semibold mb-4">Remove Inspector</h2>
            <p className="mb-6">
              Are you sure you want to remove this inspector ?
            </p>
            <div className="flex justify-center gap-4">
              <button
                onClick={handleCloseRemoveModal}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={handleRemoveInspector}
                className="px-4 py-2 bg-red-500 text-white rounded-md"
              >
                Remove
              </button>
            </div>
          </div>
        </Box>
      </Modal>

{/* ............................. Open Add Inspector Modal ..................... */}

      {openAddInspectorModal && (
        <Modal
          open={openAddInspectorModal}
          className="justiify-center items-center flex"
        >
          <Box className="bg-white text-center p-10 rounded-2xl shadow-md max-w-full mx-auto">
            <div>
              <div className="flex justify-between">
                <div>
                  <h2 className="text-2xl text-[#1C3664] font-semibold">
                    Assign Inspector
                  </h2>
                </div>
                <div>
                  <RxCrossCircled
                    onClick={handleCloseAddInspectporModal}
                    className=" top-2 h-6 w-6 cursor-pointer"
                  />
                </div>
              </div>
              <div className="relative w-full mt-6 mb-6">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={handleSearch}
                  placeholder="Search inspector by name and email"
                  className="w-full lg:w-[100%] pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              </div>
              <div className="max-h-64 overflow-y-auto">
                {inspectorData &&
                  inspectorData?.data?.map((inspector, index) => (
                    <div
                      key={inspector?._id}
                      className="flex items-start py-3 border-b last:border-b-0"
                    >
                      <input
                        type="checkbox"
                        // checked={pendingInspectors.includes(inspector?._id)}
                        checked={isInspectorSelected(inspector?._id)}
                        onChange={() =>
                          toggleInspectorSelection(inspector?._id)
                        }
                        className="mt-[6px] mr-4 form-checkbox h-4 w-4 text-blue-600 rounded border-gray-300"
                      />
                      <div className="flex gap-8">
                        <div className="flex items-center text-[#1C3664] text-sm mt-1">
                          <IoMdPerson className="mr-2 text-sm" />
                          <span>
                            {truncateString(inspector?.inspector_name)}
                          </span>
                        </div>
                        <div className="flex items-center text-[#626262] text-sm mt-1">
                          <PiPhoneOutgoingFill className="mr-2" />
                          <span>{truncateString(inspector.mobile_number)}</span>
                        </div>
                        <div className="flex items-center text-[#626262] text-sm mt-1">
                          <MdEmail className="mr-2" />
                          <span>{truncateString(inspector.email)}</span>
                        </div>
                      </div>
                    </div>
                  ))}

                {inspectorData?.data?.length === 0 && (
                  <tr>
                    <td colSpan="12" className="px-6 text-center text-gray-500">
                      <div className="flex flex-col items-center justify-center">
                        <img
                          src="https://img.freepik.com/premium-vector/no-data-concept-illustration_86047-488.jpg?semt=ais_hybrid"
                          alt="No Data"
                          className=" w-[370px] h-[200px]"
                        />
                        <p className="text-lg text-gray-500">
                          No results found
                        </p>
                        <p className="text-sm text-gray-400">
                          Please check back later or create Inspection.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </div>

              <div className="flex justify-end space-x-4 mt-6">
                <button
                  onClick={handleCloseAddInspectporModal}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAssignInspector}
                  className="px-4 py-2 bg-[#1C3664] text-white rounded-md"
                >
                  Assign Inspector
                </button>
              </div>
            </div>
          </Box>
        </Modal>
      )}

{/* .................... Open Success Modal ........................... */}

      {openSaveModal && (
        <Modal open={openSaveModal} className="justify-center items-center"
          onClose={() => {
            setOpenSaveModal(false);
            navigate(MANAGE_PROJECT);
          }}
        >
          <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
            <RxCrossCircled className="float-end top-2 h-6 w-6 cursor-pointer"
              onClick={() => {
                setOpenSaveModal(false);
                navigate(MANAGE_PROJECT);
              }}
            />
            <div className="text-center inline-flex mt-8">
              <div
                className="w-[72px] h-[72px] flex items-center justify-center"
                style={{ backgroundImage: `url(${SuccessBackground}` }}
              >
                <img src={Tick} alt="Success" className="w-7 h-7" />
              </div>
            </div>
            <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
              Success
            </p>
            <span className="text-[#6D6D6D]">New Project add successfully</span>
            <div className="mt-6 flex justify-center gap-4">
              <button className="border border-inherit px-4 py-2 rounded-lg"
                onClick={() => {
                  setOpenSaveModal(false);
                  navigate(MANAGE_PROJECT);
                }}
              >
                Close
              </button>
            </div>
          </Box>
        </Modal>
      )}
    </div>
  );
};
export default AddProject;
